/* eslint-disable @typescript-eslint/no-namespace */
import { max } from 'd3-array';
import {
  DealVersion,
  SecurityType,
  BasicMaturity
} from '../../types/deal.types';
import { DealMaturities } from '../issue/maturity';
import { STRUCTURE_GRAPH_MIN_PAR } from '../../utils/converters/value-providers';
import { MaturityViewModel } from '../../types/deal.viewmodel.types';
import { DealSummaryGridColumnName } from '../../grid/types/column.types';

export namespace DealsMaturities {
  export function getMaxPar(deals: DealVersion[]): number {
    return (max(
      deals
        .filter(
          (deal: DealVersion) => deal.maturities && deal.maturities.length
        )
        .map(DealMaturities.getMaxPar)
    ) || STRUCTURE_GRAPH_MIN_PAR) as number;
  }

  export function getSizeInMillions(maturity: BasicMaturity) {
    return maturity.securityType === SecurityType.zero
      ? typeof maturity.presentValue !== 'number'
        ? maturity.presentValue
        : maturity.presentValue / 1000
      : maturity.numberBonds;
  }

  export function getEmptyMaturityView(): MaturityViewModel {
    return {
      id: null,
      size: null,
      numberBonds: null,
      presentValue: null,
      callFeature: null,
      chartDate: null,
      putMandOpt: null,
      putDate: null,
      price: null,
      freeText: null,
      yield: null,
      sinkingFund: null,
      taxableTreasurySpread: null,
      taxableTsyMat: null,
      pacBond: null,
      yieldSpreadBump: null,
      yieldSpreadBumpValid: null,
      isOrderPeriodTerminated: null,
      couponFrequency: null,
      dayCount: null,
      priceToMaturity: null,
      yieldToMaturity: null,
      isSealedBid: null,
      isNotReoffered: null,
      isSoldNotAvailable: null,
      noRetail: null,
      ratings: null,
      taxableTsySpread: null,
      taxableTsyCoupon: null,
      taxableTsyYield: null,
      deletedInd: null,
      seriesId: '',
      securityType: null,
      insurer: null,
      coupon: null,
      cusip: null,
      maturityDate: null,
      [DealSummaryGridColumnName.Bid]: null,
      [DealSummaryGridColumnName.Ask]: null,
      [DealSummaryGridColumnName.BidYTW]: null,
      [DealSummaryGridColumnName.PricingDateTime]: null,
      [DealSummaryGridColumnName.LiquidityScore]: null,
      [DealSummaryGridColumnName.HistoricalPricing]: null
    };
  }
}
